import React, { DetailedHTMLProps, useState, useEffect, useLayoutEffect, InputHTMLAttributes, Ref } from 'react';

import clsx from 'clsx';
import PhoneInput from 'react-phone-number-input/input';

import useRandomId from 'hooks/randomIdFallback';

import styles from './PhoneNumberInput.module.scss';

export type HTMLInputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

interface TextInputProps {
  labelTitle?: string;
  errorMessage?: string;
  value?: string;
  onChange?: any;
  containerClassName?: string;
  useRequiredSymbol?: boolean;
}

export type TextInputSingleLineProps = TextInputProps & HTMLInputProps & { inputRef?: Ref<HTMLInputElement> };

const PhoneNumberInput = ({
  id: providedId,
  labelTitle,
  errorMessage,
  className,
  onChange,
  value = '',
  containerClassName,
  useRequiredSymbol = false,
  ...restProps
}: TextInputSingleLineProps) => {
  const id = useRandomId(providedId);
  const [tempValue, setTempValue] = useState(value);

  useEffect(() => {
    setTempValue(value);
  }, [value]);

  useLayoutEffect(() => {
    let trimmedValue = tempValue;

    if (tempValue) {
      trimmedValue = tempValue.slice(0, 12);
    }

    setTempValue(trimmedValue);
    onChange?.(trimmedValue);
  }, [tempValue]);

  const handleChange = (phoneNumber: string | undefined) => {
    setTempValue(phoneNumber || '');
  };

  return (
    <div className={clsx(styles.inputContainer, containerClassName)}>
      <div className={styles.labelWithLink}>
        <label htmlFor={id} className={styles.label}>
          {labelTitle}
          {useRequiredSymbol && <div className={styles.requiredInputLabel}>*</div>}
        </label>
      </div>
      <PhoneInput
        defaultCountry="US"
        className={clsx(styles.input, errorMessage && styles.inputError, className)}
        value={tempValue}
        onChange={handleChange}
        {...restProps}
      />
      {errorMessage && <p className={styles.errorNotification}>{errorMessage}</p>}
    </div>
  );
};

export default PhoneNumberInput;
